import * as React from 'react';
import styles from './JackpotLayer.module.scss';

interface JackpotLayerProps {
  value: number;
  currencySymbol?: string;
}

const formatValue = (v: number): string => {
  return v.toLocaleString('en-gb');
};

const GT_JACKPOT_CURRENCY = 'gt-jackpot_currency';
const GT_JACKPOT_VALUE = 'gt-jackpot_value';

const JackpotLayer = ({ value, currencySymbol }: JackpotLayerProps) => (
  <>
    {currencySymbol && (
      <span className={styles.text} data-testid={GT_JACKPOT_CURRENCY}>
        {currencySymbol}
      </span>
    )}
    <span className={styles.text} data-testid={GT_JACKPOT_VALUE}>
      {formatValue(value)}
    </span>
  </>
);

export default React.memo(JackpotLayer);
